import actions from 'actions'

const defaultState = {
  pendingValidation: false,
  current: null,
  images: [],
}

export default function cropper(state = defaultState, action) {
  const { type, file, src, imagePreview } = action

  switch (type) {
    case actions.CROPPER_SELECT:
      return {
        current: file.name,
        pendingValidation: true,
        images: [...state.images, { file }],
      }
    case actions.CROPPER_VALID:
      return {
        current: file.name,
        pendingValidation: false,
        images: state.images.map(image => {
          if (image.file.name === file.name) {
            return { ...image, src }
          }
          return image
        }),
      }
    case actions.CROPPER_INVALID:
    case actions.CROPPER_CANCEL:
      return {
        current: null,
        pendingValidation: false,
        images: state.images.filter(image => image.file.name !== file.name),
      }
    case actions.CROPPER_SAVE:
      return {
        current: null,
        pendingValidation: false,
        images: state.images.map(image => {
          if (image.file.name === file.name) {
            return { ...image, imagePreview }
          }
          return image
        }),
      }
    case actions.CROPPER_RESET:
      return defaultState
    default:
      return state
  }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/cropper/cropper.js
 **/